import ImportTimeShift from './ImportTimeShift'
import ImportTimeShiftGA from './ImportTimeShiftGA'
import ImportTimeShiftBranch from './ImportTimeShiftBranch'
import ImportTimeShiftHR from './ImportTimeShiftHR'
import manageShiftTransferDepartment from './manageShiftTransferDepartment'
import manageShiftTransferBranch from './manageShiftTransferBranch'
import manageShiftTransfer from './manageShiftTransfer'
import reportShiftTransferDepartment from './reportShiftTransferDepartment'
import reportShiftTransferBranch from './reportShiftTransferBranch'
import reportShiftTransfer from './reportShiftTransfer'

export default {
  ImportTimeShift,
  ImportTimeShiftGA,
  ImportTimeShiftBranch,
  ImportTimeShiftHR,
  manageShiftTransferDepartment,
  manageShiftTransferBranch,
  manageShiftTransfer,
  reportShiftTransfer,
  reportShiftTransferBranch,
  reportShiftTransferDepartment

}



// WEBPACK FOOTER //
// ./src/components/HRM/Shift/index.js